import React, { useMemo, useRef, useState } from "react"
import { RaffleContext, RaffleContextType } from "./RaffleContext"
import RaffleDebugView from "./RaffleDebugView"
import { useDebugLogs } from "../embed/components/DebugView"
import { IRaffle } from "./types"
import { currentRaffleUrl, termsTextHTML } from "./mock"
import _ from "lodash"

const MOCK_RAFFLE: IRaffle = {
  meta: {
    accept_terms_html: termsTextHTML,
    current_raffle_url: currentRaffleUrl,
    open: true,
    title: "Winter Gewinnspiel!",
    open_until: "31. Januar 2027",
    countdown_sec: 99999,
  },
  uid: "__mockRaffleUid",  
}

const STATES: [scenario: string, state: Omit<RaffleContextType, "actionGetRaffle" | "actionParticipate">][] = [
  ["init (nothing, just busy)", { busy: true }],
  ["open raffle, (not already participating)", { busy: false, raffle: MOCK_RAFFLE }],
  ["open raffle, (participation error)", { busy: false, raffle: MOCK_RAFFLE, error: "couldNotParticipate" }],
  ["open raffle, (was already participating)", { wasAlreadyParticipatingOnFirstLoad: true, busy: false, raffle: {...MOCK_RAFFLE, participation: { type: "participating", email: "mock@email.com"} }}],
  ["open raffle, (newly participating)", { busy: false, raffle: {...MOCK_RAFFLE, participation: { type: "participating", email: "mock@email.com"} }}],
  ["error, no raffle loaded", { error: "couldNotFetch", busy: false }],
  ["error, raffle loaded", { error: "couldNotParticipate", busy: false, raffle: {...MOCK_RAFFLE, participation: { type: "participating", email: "mock@email.com"} }}],
  ["closed raffle", { busy: false, raffle: {...MOCK_RAFFLE, meta: { ...MOCK_RAFFLE.meta, open: false, open_until: "Dez 31st", countdown_sec: undefined}, participation: { type: "not_participating" } }}],
  ["closed raffle, (no link)", { busy: false, raffle: {...MOCK_RAFFLE, meta: { ...MOCK_RAFFLE.meta, current_raffle_url: undefined, open: false, open_until: "Dez 31st", countdown_sec: undefined}, participation: { type: "not_participating" } }}],
]

const WithMockRaffle: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [ state, setState ] = useState<Omit<RaffleContextType, "actionGetRaffle" | "actionParticipate">>(STATES[0][1])
  const {logs, addLog} = useDebugLogs()
  const addLogRef = useRef(addLog)
  addLogRef.current = addLog

  const contextVal = useMemo<RaffleContextType>(() => ({
    ...state,
    actionGetRaffle: () => {console.log("add"); addLogRef.current("getRaffle()")},
    actionParticipate: () => addLogRef.current("participate()"),
  }), [ state ])

  return <RaffleContext.Provider value={contextVal}>
    <RaffleDebugView
      additionalActions={_.map(STATES, (st) => {
        return [ st[0], () => setState(st[1])]
      })}
      logs={logs}
    />
    {children}
  </RaffleContext.Provider>
}

export default WithMockRaffle
